export const stripeThemeOptions = {
  appearance: {
    theme: "stripe",
    // FIX: Force the inputs to condense, which tells Stripe to hide the physical label rows
    inputs: "condensed",
    labels: "none",

    variables: {
      fontFamily: "Inter, system-ui, sans-serif",
      fontSizeBase: "14px",
      colorBackground: "#ffffff",
      colorText: "#333333",
      colorPrimary: "#003273",
      borderRadius: "8px",
    },
    rules: {
      ".Label": {
        marginBottom: "0px",
      },
    },
  },
};
